/**
 * Admin routes.
 */

export const adminRoutes = [
  // Site configuration for admin users
  {
    path: "/admin/config",
    name: "adminConfig",
    component: () => import(/* webpackChunkName: "adminConfig" */ "@/views/Admin/AdminConfig.vue"),
    meta: {
      role: "admin",
      contentOnly: true,
    },
  },

  // View all payments made by this company's users (requires payments on)
  {
    path: "/admin/payments",
    name: "adminPayments",
    component: () => import(/* webpackChunkName: "adminPayments" */ "@/views/Admin/AdminPayments.vue"),
    meta: {
      role: "admin",
      payment: true,
      contentOnly: true,
    },
  },

  // Image management (for HTML editors)
  {
    path: "/admin/images",
    name: "adminImages",
    component: () => import(/* webpackChunkName: "adminImages" */ "@/views/Admin/AdminImages.vue"),
    meta: {
      role: "admin",
      contentOnly: true,
      // title: { title: "banner_title_admin_images", titleTranslated: false, subtitle: "" },
      // breadcrumbs: [
      //   { url: "/admin/2", url_absolute: true, text: "breadcrumb_admin" }, // TODO: correct URL
      //   { target: { name: "adminImages" }, text: "breadcrumb_admin_images" },
      // ],
    },
  },

  // Page add / edit
  {
    path: "/admin/page/:pageId?",
    name: "adminPage",
    component: () => import(/* webpackChunkName: "adminPage" */ "@/views/Admin/AdminPage.vue"),
    meta: {
      role: "admin",
      title: { title: "banner_title_admin_page", titleTranslated: false, subtitle: "" },
      breadcrumbs: [
        { url: "/admin/2", url_absolute: true, text: "breadcrumb_admin" },
        { target: { name: "adminPage" }, text: "breadcrumb_admin_page" },
      ],
    },
  },
];
